(function () {
  'use strict';

  /* ---------------------------------------------------------
     Shared audio arbitration — only one sound source (the
     persistent dock player, a per-product preview player, or
     the Demo step-sequencer) should ever play at once. Every
     player/sequencer registers a "stop" callback here and calls
     pauseOtherAudio() when it starts, which stops everything
     else currently registered.
     --------------------------------------------------------- */
  var activeAudioSources = [];

  function registerAudioSource(stopFn) {
    activeAudioSources.push(stopFn);
  }

  function pauseOtherAudio(exceptFn) {
    activeAudioSources.forEach(function (stopFn) {
      if (stopFn !== exceptFn) stopFn();
    });
  }

  /* ---------------------------------------------------------
     Product image thumbnails
     --------------------------------------------------------- */
  window.initProductThumbnails = function (scope) {
    scope = scope || document;
    scope.querySelectorAll('.win-product__thumb').forEach(function (thumb) {
      if (thumb.dataset.thumbInitialized === 'true') return;
      thumb.dataset.thumbInitialized = 'true';
      thumb.addEventListener('click', function () {
        var main = document.getElementById('ProductMainImage');
        var src = thumb.getAttribute('data-thumb-src');
        if (main && src) main.src = src;
      });
    });
  };

  /* ---------------------------------------------------------
     Quantity steppers (product form + cart)
     --------------------------------------------------------- */
  window.initQtySteppers = function (scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-qty-increase], [data-qty-decrease]').forEach(function (btn) {
      if (btn.dataset.qtyInitialized === 'true') return;
      btn.dataset.qtyInitialized = 'true';
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.win-qty-stepper');
        if (!wrap) return;
        var input = wrap.querySelector('input[type="number"]');
        if (!input) return;
        var min = parseInt(input.min, 10) || 0;
        var val = parseInt(input.value, 10) || min;
        if (btn.hasAttribute('data-qty-increase')) {
          val += 1;
        } else {
          val = Math.max(min, val - 1);
        }
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  };

  /* ---------------------------------------------------------
     Product variant picker: keep hidden variant id + price in
     sync with the selected option dropdowns.
     --------------------------------------------------------- */
  window.initProductForms = function (scope) {
    scope = scope || document;
    scope.querySelectorAll('.win-product-form').forEach(function (form) {
      if (form.dataset.variantPickerInitialized === 'true') return;
      form.dataset.variantPickerInitialized = 'true';

      var section = form.closest('.win-product');
      if (!section) return;

      var variantsScript = section.parentElement.querySelector('script[id^="ProductVariants-"]');
      if (!variantsScript) return;

      var variants;
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (err) {
        return;
      }

      var optionSelectors = form.querySelectorAll('[data-option-selector]');
      var hiddenId = form.querySelector('[data-variant-id]');
      var priceEl = section.querySelector('[data-product-price]');
      var comparePriceEl = section.querySelector('[data-product-compare-price]');
      var saleBadgeEl = section.querySelector('[data-product-sale-badge]');
      var availabilityEl = section.querySelector('[data-product-availability]');
      var addBtn = section.querySelector('[data-add-to-cart]');
      var addBtnText = section.querySelector('[data-add-to-cart-text]');

      function currentSelection() {
        var selected = [];
        optionSelectors.forEach(function (sel) {
          selected.push(sel.value);
        });
        return selected;
      }

      function findMatchingVariant(selected) {
        return variants.find(function (variant) {
          var options = [variant.option1, variant.option2, variant.option3].filter(function (o) {
            return o !== null && o !== undefined;
          });
          return options.length === selected.length && options.every(function (opt, i) {
            return opt === selected[i];
          });
        });
      }

      function formatMoney(cents) {
        return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' });
      }

      var labelAvailable = section.dataset.labelAvailable || 'Ready';
      var labelSoldout = section.dataset.labelSoldout || 'Sold Out';
      var labelAddToCart = section.dataset.labelAddToCart || 'Add to Cart';
      var labelSoldOutBtn = section.dataset.labelSoldOutBtn || 'Sold Out';

      function handleChange() {
        var match = findMatchingVariant(currentSelection());
        if (!match) return;

        if (hiddenId) hiddenId.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);

        var onSale = match.compare_at_price && match.compare_at_price > match.price;
        if (comparePriceEl) {
          comparePriceEl.hidden = !onSale;
          if (onSale) comparePriceEl.textContent = formatMoney(match.compare_at_price);
        }
        if (saleBadgeEl) {
          saleBadgeEl.hidden = !onSale;
        }

        if (availabilityEl) availabilityEl.textContent = match.available ? labelAvailable : labelSoldout;

        if (addBtn) {
          addBtn.disabled = !match.available;
        }
        if (addBtnText) {
          addBtnText.textContent = match.available ? labelAddToCart : labelSoldOutBtn;
        }
      }

      optionSelectors.forEach(function (sel) {
        sel.addEventListener('change', handleChange);
      });
    });
  };

  /* ---------------------------------------------------------
     Media player — used by both the per-product preview player
     and the global playlist player. Each [data-win-player] root
     carries a sibling <script data-player-tracks> JSON array of
     { src, title, artist, cover } objects (length 1 for a single
     product preview, length N for a playlist).
     --------------------------------------------------------- */
  window.initWinPlayers = function (scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-win-player]').forEach(function (root) {
      if (root.dataset.playerInitialized === 'true') return;
      root.dataset.playerInitialized = 'true';
      initSinglePlayer(root);
    });
  };

  function initSinglePlayer(root) {
    var tracksEl = root.querySelector('script[data-player-tracks]');
    if (!tracksEl) return;

    var tracks;
    try {
      tracks = JSON.parse(tracksEl.textContent);
    } catch (err) {
      return;
    }
    if (!tracks || !tracks.length) return;

    var audio = root.querySelector('[data-player-audio]');
    var toggleBtn = root.querySelector('[data-player-toggle]');
    var mobileToggle = root.querySelector('[data-player-mobile-toggle]');
    var prevBtn = root.querySelector('[data-player-prev]');
    var nextBtn = root.querySelector('[data-player-next]');
    var scrub = root.querySelector('[data-player-scrub]');
    var volume = root.querySelector('[data-player-volume]');
    var currentTimeEl = root.querySelector('[data-player-current]');
    var durationEl = root.querySelector('[data-player-duration]');
    var titleEl = root.querySelector('[data-player-title]');
    var artistEl = root.querySelector('[data-player-artist]');
    var coverImg = root.querySelector('[data-player-cover-img]');
    var playlistEl = root.querySelector('[data-player-playlist]');
    var filterToggleBtn = root.querySelector('[data-player-filter-toggle]');
    var waveformEl = root.querySelector('[data-player-waveform]');
    var waveformPlayedEl = root.querySelector('[data-player-waveform-played]');
    var trackEls = playlistEl
      ? Array.prototype.slice.call(playlistEl.querySelectorAll('[data-player-track-index]'))
      : [];

    if (!audio) return;

    /* -------------------------------------------------------
       Optional Web Audio "old speaker" filter — only wired up
       for players that have a filter-toggle button (the
       persistent dock player). Everything else just uses plain
       audio.volume, no Web Audio graph needed.
       ------------------------------------------------------- */
    var masterGain = null;
    var filterOn = root.dataset.filterDefault !== 'off';

    if (filterToggleBtn && (window.AudioContext || window.webkitAudioContext)) {
      try {
        var AudioCtx = window.AudioContext || window.webkitAudioContext;
        var ctx = new AudioCtx();
        var source = ctx.createMediaElementSource(audio);

        // "Dry" (unfiltered) path
        var dryGain = ctx.createGain();

        // "Wet" (old-speaker) path: narrow the frequency range and
        // add a little grit, like sound coming out of a small,
        // cheap, worn-out speaker cone.
        var highpass = ctx.createBiquadFilter();
        highpass.type = 'highpass';
        highpass.frequency.value = 500;
        var lowpass = ctx.createBiquadFilter();
        lowpass.type = 'lowpass';
        lowpass.frequency.value = 3200;
        var bandpass = ctx.createBiquadFilter();
        bandpass.type = 'peaking';
        bandpass.frequency.value = 1500;
        bandpass.Q.value = 1;
        bandpass.gain.value = 3;
        var shaper = ctx.createWaveShaper();
        (function () {
          var curve = new Float32Array(256);
          for (var i = 0; i < 256; i++) {
            var x = (i / 255) * 2 - 1;
            curve[i] = Math.tanh(x * 1.4);
          }
          shaper.curve = curve;
        })();
        // The narrow-band + peaking-boost + saturation chain above reads
        // as noticeably louder than the plain dry signal even though
        // nothing here raises the overall gain on purpose. This trim
        // brings the wet path back down by roughly 7dB (10^(-7/20) ≈
        // 0.45) so switching the filter on/off doesn't jump in volume.
        var wetTrim = ctx.createGain();
        wetTrim.gain.value = 0.45;
        var wetGain = ctx.createGain();

        masterGain = ctx.createGain();
        masterGain.gain.value = parseFloat(root.dataset.defaultVolume || '0.1');

        source.connect(dryGain);
        dryGain.connect(masterGain);

        source.connect(highpass);
        highpass.connect(lowpass);
        lowpass.connect(bandpass);
        bandpass.connect(shaper);
        shaper.connect(wetTrim);
        wetTrim.connect(wetGain);
        wetGain.connect(masterGain);

        masterGain.connect(ctx.destination);

        function applyFilterState() {
          dryGain.gain.value = filterOn ? 0 : 1;
          wetGain.gain.value = filterOn ? 1 : 0;
        }
        applyFilterState();

        filterToggleBtn.addEventListener('click', function () {
          filterOn = !filterOn;
          applyFilterState();
          filterToggleBtn.setAttribute('aria-pressed', filterOn ? 'true' : 'false');
        });

        // Autoplay policies suspend new AudioContexts until a user
        // gesture; resume on first play attempt.
        audio.addEventListener('play', function () {
          if (ctx.state === 'suspended') ctx.resume();
        });
      } catch (err) {
        masterGain = null;
      }
    }

    var index = 0;
    var isSeeking = false;

    function formatTime(sec) {
      if (!isFinite(sec) || sec < 0) sec = 0;
      var m = Math.floor(sec / 60);
      var s = Math.floor(sec % 60);
      return m + ':' + (s < 10 ? '0' : '') + s;
    }

    /* -------------------------------------------------------
       Waveform preview — decodes the track with the Web Audio
       API, downsamples it into a handful of peak/amplitude
       bars, and renders two copies of the same bars: a base
       layer and a "played" layer that gets clipped by the
       existing --progress CSS variable (already kept up to
       date by the scrub/timeupdate handlers below). Purely
       cosmetic, so any decode/CORS failure just quietly skips.
       ------------------------------------------------------- */
    var waveformCache = {};

    function renderWaveformBars(container, peaks) {
      if (!container) return;
      container.innerHTML = '';
      var frag = document.createDocumentFragment();
      for (var i = 0; i < peaks.length; i++) {
        var bar = document.createElement('span');
        bar.className = 'win-player__waveform-bar';
        bar.style.height = Math.max(8, Math.round(peaks[i] * 100)) + '%';
        frag.appendChild(bar);
      }
      container.appendChild(frag);
    }

    function buildWaveform(i) {
      if (!waveformEl) return;
      if (waveformCache[i]) {
        renderWaveformBars(waveformEl, waveformCache[i]);
        renderWaveformBars(waveformPlayedEl, waveformCache[i]);
        return;
      }
      var t = tracks[i];
      if (!t || !t.src) return;
      var AudioCtx = window.AudioContext || window.webkitAudioContext;
      if (!AudioCtx) return;

      fetch(t.src)
        .then(function (res) { return res.arrayBuffer(); })
        .then(function (buf) {
          var decodeCtx = new AudioCtx();
          return decodeCtx.decodeAudioData(buf).then(function (audioBuffer) {
            var raw = audioBuffer.getChannelData(0);
            var barCount = 60;
            var blockSize = Math.max(1, Math.floor(raw.length / barCount));
            var peaks = [];
            for (var b = 0; b < barCount; b++) {
              var start = b * blockSize;
              var sum = 0;
              for (var j = 0; j < blockSize; j++) {
                sum += Math.abs(raw[start + j] || 0);
              }
              peaks.push(sum / blockSize);
            }
            var max = 0;
            for (var k = 0; k < peaks.length; k++) {
              if (peaks[k] > max) max = peaks[k];
            }
            if (max > 0) {
              peaks = peaks.map(function (p) { return p / max; });
            }
            waveformCache[i] = peaks;
            if (index === i) {
              renderWaveformBars(waveformEl, peaks);
              renderWaveformBars(waveformPlayedEl, peaks);
            }
            if (decodeCtx.close) decodeCtx.close();
          });
        })
        .catch(function () {
          /* Waveform is a nice-to-have visual; silently skip on failure. */
        });
    }

    function loadTrack(i, autoplay) {
      index = ((i % tracks.length) + tracks.length) % tracks.length;
      var t = tracks[index];
      audio.src = t.src;
      if (titleEl) titleEl.textContent = t.title || '';
      if (artistEl) artistEl.textContent = t.artist || '';
      if (coverImg && t.cover) coverImg.src = t.cover;
      trackEls.forEach(function (el) {
        el.classList.toggle('is-active', parseInt(el.getAttribute('data-player-track-index'), 10) === index);
      });
      if (scrub) scrub.value = 0;
      root.style.setProperty('--progress', '0%');
      if (currentTimeEl) currentTimeEl.textContent = '0:00';
      if (durationEl) durationEl.textContent = '0:00';
      if (waveformEl) {
        waveformEl.innerHTML = '';
        if (waveformPlayedEl) waveformPlayedEl.innerHTML = '';
        buildWaveform(index);
      }
      if (autoplay) {
        audio.play().catch(function () {});
      }
    }

    loadTrack(0, false);

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        if (audio.paused) {
          audio.play().catch(function () {});
        } else {
          audio.pause();
        }
      });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { loadTrack(index - 1, true); });
    if (nextBtn) nextBtn.addEventListener('click', function () { loadTrack(index + 1, true); });

    trackEls.forEach(function (el) {
      el.addEventListener('click', function () {
        loadTrack(parseInt(el.getAttribute('data-player-track-index'), 10), true);
      });
    });

    /* -------------------------------------------------------
       Mobile-only expand/collapse. Only present on the dock
       player (media-player.liquid) — the product-page preview
       player has no mobile-toggle button, so this whole block
       is a no-op there.
       ------------------------------------------------------- */
    if (mobileToggle) {
      mobileToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var isExpanded = root.classList.toggle('is-mobile-expanded');
        mobileToggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) {
        if (root.classList.contains('is-mobile-expanded') && !root.contains(e.target)) {
          root.classList.remove('is-mobile-expanded');
          mobileToggle.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && root.classList.contains('is-mobile-expanded')) {
          root.classList.remove('is-mobile-expanded');
          mobileToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    function stopThisPlayer() {
      if (!audio.paused) audio.pause();
    }
    registerAudioSource(stopThisPlayer);

    audio.addEventListener('play', function () {
      root.classList.add('is-playing');
      if (toggleBtn) toggleBtn.innerHTML = '<span class="win-icon-pause" aria-hidden="true"><span></span><span></span></span>';
      pauseOtherAudio(stopThisPlayer);
    });
    audio.addEventListener('pause', function () {
      root.classList.remove('is-playing');
      if (toggleBtn) toggleBtn.innerHTML = '<i class="win-icon-tri" aria-hidden="true"></i>';
    });
    audio.addEventListener('ended', function () {
      if (tracks.length > 1) loadTrack(index + 1, true);
    });
    audio.addEventListener('loadedmetadata', function () {
      if (durationEl) durationEl.textContent = formatTime(audio.duration);
    });
    audio.addEventListener('timeupdate', function () {
      if (isSeeking) return;
      if (currentTimeEl) currentTimeEl.textContent = formatTime(audio.currentTime);
      if (audio.duration && scrub) {
        var pct = (audio.currentTime / audio.duration) * 1000;
        scrub.value = pct;
        root.style.setProperty('--progress', (pct / 10) + '%');
      }
    });

    if (scrub) {
      scrub.addEventListener('input', function () {
        isSeeking = true;
        var pct = scrub.value / 1000;
        root.style.setProperty('--progress', (pct * 100) + '%');
        if (audio.duration && currentTimeEl) {
          currentTimeEl.textContent = formatTime(pct * audio.duration);
        }
      });
      scrub.addEventListener('change', function () {
        if (audio.duration) {
          audio.currentTime = (scrub.value / 1000) * audio.duration;
        }
        isSeeking = false;
      });
    }

    if (volume) {
      if (masterGain) {
        masterGain.gain.value = parseFloat(volume.value);
      } else {
        audio.volume = parseFloat(volume.value);
      }
      volume.addEventListener('input', function () {
        if (masterGain) {
          masterGain.gain.value = parseFloat(volume.value);
        } else {
          audio.volume = parseFloat(volume.value);
        }
      });
    }
  }

  /* ---------------------------------------------------------
     Start bar popup menu (social links). Static section, lives
     outside #MainContent, so this only needs to run once.
     --------------------------------------------------------- */
  function initStartMenu() {
    document.querySelectorAll('[data-start-toggle]').forEach(function (btn) {
      var menu = document.getElementById(btn.getAttribute('aria-controls'));
      if (!menu) return;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = !menu.hasAttribute('hidden');
        if (isOpen) {
          menu.setAttribute('hidden', '');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          menu.removeAttribute('hidden');
          btn.setAttribute('aria-expanded', 'true');
        }
      });

      document.addEventListener('click', function (e) {
        if (!menu.contains(e.target) && e.target !== btn) {
          menu.setAttribute('hidden', '');
          btn.setAttribute('aria-expanded', 'false');
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          menu.setAttribute('hidden', '');
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  /* ---------------------------------------------------------
     Hero window height (home page only)
     ---------------------------------------------------------
     The hero window's CSS height is computed from the viewport
     (100vh minus the taskbar and its own margins). That works in
     most browsers, but it depends on every ancestor resolving a
     definite height correctly, which isn't something we can rely
     on in all cases. This measures the *real* on-screen taskbar
     height and viewport size and sets the hero's height inline,
     which always wins regardless of any CSS cascade issue, so the
     window's bottom border is guaranteed to land on-screen with
     no scrolling. Runs after every page load/navigation and on
     resize, since the numbers change with viewport size.
     --------------------------------------------------------- */
  function sizeHeroWindow() {
    var hero = document.querySelector('.win-hero');
    if (!hero) return;
    var taskbar = document.querySelector('.win-taskbar');
    var taskbarHeight = taskbar ? taskbar.getBoundingClientRect().height : 46;
    var style = window.getComputedStyle(hero);
    var marginBottom = parseFloat(style.marginBottom) || 0;
    // Measure the hero's actual on-screen top position instead of
    // assuming it starts at y=0 plus its own margin. On desktop the
    // sidebar sits beside the content (0 vertical footprint), but on
    // mobile it's a horizontal strip stacked above the window frame —
    // getBoundingClientRect().top already reflects real rendered
    // position either way, so this stays correct on both layouts
    // without needing separate math per breakpoint.
    var top = hero.getBoundingClientRect().top;
    var available = window.innerHeight - taskbarHeight - top - marginBottom;
    if (available > 100) {
      hero.style.height = available + 'px';
      hero.style.maxHeight = available + 'px';
    }
  }
  window.sizeHeroWindow = sizeHeroWindow;
  window.addEventListener('resize', sizeHeroWindow);

  /* ---------------------------------------------------------
     Demo sequencer (Demo page). Visitors tap steps to build their
     own beat out of the pack's Kick/Clap/Bass/Hat/Lead samples,
     then hit play. Uses the Web Audio API with a standard
     lookahead scheduler (timer polls slightly ahead of playback
     and schedules exact-timed AudioBufferSourceNodes) so steps
     stay tight even though the visual timer itself is imprecise.
     --------------------------------------------------------- */
  window.initSequencers = function (scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-sequencer]').forEach(function (root) {
      if (root.dataset.sequencerInitialized === 'true') return;
      root.dataset.sequencerInitialized = 'true';
      initSingleSequencer(root);
    });
  };

  function initSingleSequencer(root) {
    var tracksEl = root.querySelector('script[data-sequencer-tracks]');
    if (!tracksEl) return;

    var tracksData;
    try {
      tracksData = JSON.parse(tracksEl.textContent);
    } catch (err) {
      return;
    }

    var toggleBtn = root.querySelector('[data-sequencer-toggle]');
    var clearBtn = root.querySelector('[data-sequencer-clear]');
    var tempoInput = root.querySelector('[data-sequencer-tempo]');
    var tempoValueEl = root.querySelector('[data-sequencer-tempo-value]');
    var volumeInput = root.querySelector('[data-sequencer-volume]');

    var tracks = tracksData
      .filter(function (t) { return t.src; })
      .map(function (t) {
        var rowEl = root.querySelector('[data-sequencer-track][data-track-key="' + t.key + '"]');
        var stepButtons = rowEl
          ? Array.prototype.slice.call(rowEl.querySelectorAll('[data-sequencer-step]'))
          : [];
        return { key: t.key, label: t.label, src: t.src, buffer: null, loading: false, stepButtons: stepButtons };
      });

    var STEP_COUNT = 16;
    var audioCtx = null;
    var masterGain = null;
    var pendingVolume = volumeInput ? parseFloat(volumeInput.value) : parseFloat(root.dataset.defaultVolume || '0.8');
    var isPlaying = false;
    var currentStep = 0;
    var nextStepTime = 0.0;
    var tempo = parseFloat(root.dataset.defaultTempo) || 120;
    var timerID = null;
    var lookahead = 25.0; // ms between scheduler checks
    var scheduleAheadTime = 0.1; // seconds of lookahead per check

    function ensureContext() {
      if (audioCtx) return audioCtx;
      var AudioCtx = window.AudioContext || window.webkitAudioContext;
      if (!AudioCtx) return null;
      audioCtx = new AudioCtx();
      masterGain = audioCtx.createGain();
      masterGain.gain.value = pendingVolume;
      masterGain.connect(audioCtx.destination);
      return audioCtx;
    }

    function loadTrackBuffer(track) {
      if (track.buffer || track.loading || !track.src) return;
      var ctx = ensureContext();
      if (!ctx) return;
      track.loading = true;
      fetch(track.src)
        .then(function (res) { return res.arrayBuffer(); })
        .then(function (data) { return ctx.decodeAudioData(data); })
        .then(function (buf) {
          track.buffer = buf;
          track.loading = false;
        })
        .catch(function () {
          track.loading = false;
        });
    }

    // Preload every configured track up front so the first press of
    // play isn't waiting on a network fetch.
    tracks.forEach(loadTrackBuffer);

    tracks.forEach(function (track) {
      track.stepButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          btn.classList.toggle('is-active');
        });
      });
    });

    function highlightStep(stepIndex) {
      tracks.forEach(function (track) {
        track.stepButtons.forEach(function (btn, i) {
          btn.classList.toggle('is-current', i === stepIndex);
        });
      });
    }

    function clearHighlight() {
      tracks.forEach(function (track) {
        track.stepButtons.forEach(function (btn) {
          btn.classList.remove('is-current');
        });
      });
    }

    function scheduleStep(stepIndex, time) {
      tracks.forEach(function (track) {
        var btn = track.stepButtons[stepIndex];
        if (btn && btn.classList.contains('is-active') && track.buffer) {
          var src = audioCtx.createBufferSource();
          src.buffer = track.buffer;
          src.connect(masterGain);
          src.start(time);
        }
      });
      var delayMs = Math.max(0, (time - audioCtx.currentTime) * 1000);
      window.setTimeout(function () {
        if (isPlaying) highlightStep(stepIndex);
      }, delayMs);
    }

    function advanceStep() {
      var secondsPerStep = 60.0 / tempo / 4; // 16th notes
      nextStepTime += secondsPerStep;
      currentStep = (currentStep + 1) % STEP_COUNT;
    }

    function schedulerLoop() {
      while (nextStepTime < audioCtx.currentTime + scheduleAheadTime) {
        scheduleStep(currentStep, nextStepTime);
        advanceStep();
      }
      timerID = window.setTimeout(schedulerLoop, lookahead);
    }

    function setToggleIcon(playing) {
      if (!toggleBtn) return;
      toggleBtn.innerHTML = playing
        ? '<span class="win-icon-pause" aria-hidden="true"><span></span><span></span></span>'
        : '<i class="win-icon-tri" aria-hidden="true"></i>';
    }

    function stopThisSequencer() {
      if (isPlaying) stop();
    }
    registerAudioSource(stopThisSequencer);

    function start() {
      var ctx = ensureContext();
      if (!ctx) return;
      if (ctx.state === 'suspended') ctx.resume();
      pauseOtherAudio(stopThisSequencer);
      isPlaying = true;
      currentStep = 0;
      nextStepTime = ctx.currentTime + 0.05;
      schedulerLoop();
      setToggleIcon(true);
    }

    function stop() {
      isPlaying = false;
      if (timerID) window.clearTimeout(timerID);
      clearHighlight();
      setToggleIcon(false);
    }

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        if (isPlaying) stop(); else start();
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        tracks.forEach(function (track) {
          track.stepButtons.forEach(function (btn) {
            btn.classList.remove('is-active');
          });
        });
      });
    }

    if (tempoInput) {
      tempoInput.addEventListener('input', function () {
        tempo = parseFloat(tempoInput.value) || 120;
        if (tempoValueEl) tempoValueEl.textContent = Math.round(tempo) + ' BPM';
      });
    }

    if (volumeInput) {
      volumeInput.addEventListener('input', function () {
        pendingVolume = parseFloat(volumeInput.value);
        if (masterGain) masterGain.gain.value = pendingVolume;
      });
    }
  }

  /* ---------------------------------------------------------
     Run every per-page init routine against a given scope.
     Called once on real page load, and again after every pjax
     content swap (scoped to the freshly-inserted #MainContent
     subtree only). The persistent sidebar + dock player live
     outside #MainContent and are never re-initialized here.
     --------------------------------------------------------- */
  window.initPageScripts = function (scope) {
    scope = scope || document;
    window.sizeHeroWindow();
    window.initProductForms(scope);
    window.initQtySteppers(scope);
    window.initProductThumbnails(scope);
    window.initWinPlayers(scope);
    window.initSequencers(scope);
  };

  /* ---------------------------------------------------------
     App-style navigation (pjax)
     ---------------------------------------------------------
     Internal link clicks and the search/product forms are
     intercepted and resolved via fetch() so that only the
     #MainContent pane is swapped. The persistent sidebar and
     dock media player live outside #MainContent, so playback
     never stops as the visitor browses. Checkout, account,
     admin and cart links are excluded and always do a real,
     full navigation instead: checkout is hosted on a separate
     Shopify domain, and the cart page's contents are exactly
     the kind of highly-mutable state that must never be served
     from a stale fetch()/cache snapshot instead of a fresh
     server round-trip.
     --------------------------------------------------------- */
  var EXCLUDED_PATH_RE = /^\/(checkout|account|admin|cart)(\/|$)/i;

  function isPjaxLink(link) {
    if (!link || !link.getAttribute) return false;
    var href = link.getAttribute('href');
    if (!href) return false;
    if (link.target && link.target !== '' && link.target !== '_self') return false;
    if (link.hasAttribute('download')) return false;
    if (link.dataset && link.dataset.noPjax !== undefined) return false;
    if (link.hasAttribute('rel') && (link.getAttribute('rel') || '').indexOf('external') !== -1) return false;

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (err) {
      return false;
    }
    if (url.origin !== window.location.origin) return false;
    if (EXCLUDED_PATH_RE.test(url.pathname)) return false;
    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash !== '') {
      return false; // pure in-page anchor jump
    }
    return true;
  }

  function getMainContent() {
    return document.getElementById('MainContent');
  }

  function refreshCartBadge() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function navigateTo(url, opts) {
    opts = opts || {};
    var push = opts.push !== false;
    var currentMain = getMainContent();
    if (!currentMain) {
      window.location.href = url;
      return;
    }

    fetch(url, { headers: { 'X-Requested-With': 'Fetch' }, cache: 'no-store' })
      .then(function (res) {
        if (!res.ok) throw new Error('Bad response');
        return res.text().then(function (html) {
          return { html: html, url: res.url };
        });
      })
      .then(function (result) {
        var doc = new DOMParser().parseFromString(result.html, 'text/html');
        var newMain = doc.getElementById('MainContent');
        var freshMain = getMainContent();
        if (!newMain || !freshMain) {
          window.location.href = url;
          return;
        }

        freshMain.innerHTML = newMain.innerHTML;
        if (doc.title) document.title = doc.title;

        if (push) {
          history.pushState({ pjax: true }, '', result.url || url);
        } else {
          history.replaceState({ pjax: true }, '', result.url || url);
        }

        freshMain.scrollTop = 0;
        window.scrollTo(0, 0);

        window.initPageScripts(freshMain);
        refreshCartBadge();
        document.dispatchEvent(new CustomEvent('pjax:loaded', { detail: { url: result.url || url } }));
      })
      .catch(function () {
        // Network hiccup or unexpected response shape: never trap
        // the visitor, fall back to a normal full navigation.
        window.location.href = url;
      });
  }
  window.winNavigateTo = navigateTo;

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    if (e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest('a[href]');
    if (!link || !isPjaxLink(link)) return;
    e.preventDefault();
    navigateTo(link.href, { push: true });
  });

  window.addEventListener('popstate', function () {
    navigateTo(window.location.href, { push: false });
  });

  /* ---------------------------------------------------------
     AJAX add-to-cart (product form)
     --------------------------------------------------------- */
  function handleAddToCart(form) {
    var formData = new FormData(form);
    var addBtn = form.querySelector('[data-add-to-cart]');
    var successMsg = form.querySelector('[data-cart-success]');
    if (addBtn) addBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) throw new Error((result.data && result.data.description) || 'Could not add to cart');
        if (successMsg) {
          successMsg.hidden = false;
          window.clearTimeout(successMsg._hideTimer);
          successMsg._hideTimer = window.setTimeout(function () {
            successMsg.hidden = true;
          }, 3000);
        }
        refreshCartBadge();
      })
      .catch(function () {
        // Fall back to a real form submission so the customer can
        // still complete the action.
        form.submit();
      })
      .finally(function () {
        if (addBtn) addBtn.disabled = false;
      });
  }

  /* ---------------------------------------------------------
     AJAX cart quantity updates (cart page "Update Cart")
     --------------------------------------------------------- */
  function handleCartUpdate(form) {
    // Keyed by each line's unique cart item key (set via data-cart-line-key
    // in main-cart.liquid), not by row position. Position-based updates
    // (the old `updates[i + 1]` array-index approach) intermittently failed
    // to resolve against the live server-side cart, so every line is now
    // addressed by Shopify's own stable per-line identifier instead.
    var qtyInputs = Array.prototype.slice.call(form.querySelectorAll('input[data-cart-line-key]'));
    var updates = {};
    qtyInputs.forEach(function (input) {
      var key = input.getAttribute('data-cart-line-key');
      if (key) updates[key] = parseInt(input.value, 10) || 0;
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Bad response');
        return res.json();
      })
      .then(function () {
        // Full real reload rather than the pjax fetch/swap, so the cart
        // page always reflects a truly fresh server render after a mutation.
        window.location.reload();
      })
      .catch(function () {
        form.submit();
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;

    if (form.classList.contains('win-cart-form')) {
      var submitter = e.submitter;
      if (submitter && submitter.name === 'checkout') {
        return; // real navigation to Shopify-hosted checkout
      }
      e.preventDefault();
      handleCartUpdate(form);
      return;
    }

    if (form.classList.contains('win-product-form')) {
      e.preventDefault();
      handleAddToCart(form);
      return;
    }

    if (form.classList.contains('win-search')) {
      var method = (form.getAttribute('method') || 'get').toLowerCase();
      if (method === 'get') {
        e.preventDefault();
        var params = new URLSearchParams(new FormData(form));
        navigateTo(form.action + '?' + params.toString(), { push: true });
      }
    }
  });

  initStartMenu();
  window.initPageScripts(document);
})();
